import {
  Box,
  KdsCardFile,
  KdsEmptyContent,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { isWorkflowWithQuote } from "@/helpers/validators/isWorkflowWithQuote";
import { useFile } from "@/hooks/queries/useFile";
import { type ValidatedQuoteBlocProps } from "./ValidatedQuoteBloc.types";

export const ValidatedQuoteBloc = ({ orderItem }: ValidatedQuoteBlocProps) => {
  const { t } = useTranslate();

  const { useDownloadFileHandler } = useFile();
  const { handleDownloadFile } = useDownloadFileHandler();

  const validatedQuote = orderItem?.sandboxItem.SandboxItemQuote.find(
    (q) => q.id === orderItem.sandboxItemQuoteId
  );

  if (!isWorkflowWithQuote(orderItem.Workflow.workflowType)) {
    return null;
  }

  return (
    <Box w="100%" rounded="br-md" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <KdsText size="title-sm">
          {t("order.myOrdersItemDetails.selectedQuote")}
        </KdsText>

        <Box maxH="450px" overflowY="auto">
          <VStack gap="sp-md">
            {!validatedQuote ? (
              <KdsEmptyContent
                title={t("documentEmptyState.title")}
                description={t("documentEmptyState.subtitle")}
              />
            ) : (
              <KdsCardFile
                fileName={validatedQuote.file.fileName}
                fileSize={validatedQuote.file.size}
                fileUrl={validatedQuote.file.url}
                isViewable
                isDownloadable
                onDownload={() =>
                  handleDownloadFile(
                    validatedQuote.file.fileName,
                    validatedQuote.file.url
                  )
                }
              />
            )}
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};
